import React, { PureComponent } from "react";
import { connect } from "react-redux";
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu/Menu';
import MenuItem from '@mui/material/MenuItem/MenuItem';
import { MoreVert as MoreVertIcon } from '@mui/icons-material';
import { Modal, Text, TextInput, Theme } from '@simplybenefits/sb-ui-library';
import * as dates from '@simplybenefits/sb-dates';
import { helpers } from '@simplybenefits/sb-utils';
import store from '../../../redux/store.js';
import { changeClaimStatus, reassignClaim, dentalReversalCheck, reverseDentalClaim } from '../../../actions/adjudication.js';
import PermissionsComponent from '../../../components/PermissionsComponent.js';
import ReverseDentalClaimModal from "./ReverseDentalClaimModal.js";

import { styled } from '@mui/system';

const StyledBlockRow = styled('div')(() => ({
    alignItems: 'center',
    backgroundColor: Theme.colors.subHeaderGrey,
    cursor: 'pointer',
    display: 'flex',
    flex: 1,
    flexDirection: 'row',
    height: 60,
    marginBottom: 5,
    '&:hover': { filter: 'brightness(97%)' }
}));

class ClaimBlock extends PureComponent {
    state = {
        anchorEl: null,
        showChangeStatus: false,
        showReassign: false,
        showDentalReversal: false,
        reversalDetails: {},
        newStatus: null,
        assignTo: null
    };

    _handleMenuClick = (event) => {
        this.setState({ anchorEl: event.currentTarget });
    };

    _handleCloseMenu = () => {
        this.setState({ anchorEl: null });
    };

    _openModal = (type) => {
        this.setState({
            [type]: true,
            anchorEl: null,
            newStatus: this.props.status.charAt(0).toUpperCase() + this.props.status.slice(1),
            assignTo: this.props.adjudicators[this.props.adjudicators.length - 1]
        });
    };

    _closeModal = () => {
        this.setState({
            showChangeStatus: false,
            showReassign: false,
            newStatus: null,
            assignTo: null,
            showDentalReversal: false
        });
    };

    _handleInputChange = async (type, value) => {
        await this.setState({
            [type]: value
        });
    };

    _saveStatus = async () => {

        this.setState({
            showChangeStatus: false,
            showReassign: false
        });

        const success = await this.props.dispatch(changeClaimStatus(this.props.claimID, this.state.newStatus, this.props.isAdjudicationList, this.props.isSpendingAccount, this.props.claimType));

        if (success) {
            this._closeModal();
        }
    };

    _reassign = async () => {
        this.setState({
            showChangeStatus: false,
            showReassign: false
        });

        const adjudicator = store.getState().master.adjudicators.find((item) => `${ item.firstname } ${ item.lastname }` === this.state.assignTo);
        const success = await this.props.dispatch(reassignClaim(this.props.claimID, adjudicator.masterID, this.props.isAdjudicationList, this.props.isSpendingAccount, this.props.claimType));

        if (success) {
            this._closeModal();
        }
    };

    _doDentalReversalStatusCheck = async () => {
        const reversalDetails = await this.props.dispatch(dentalReversalCheck(this.props.claimID));

        if (reversalDetails) {
            this.setState({
                showDentalReversal: true,
                anchorEl: null,
                reversalDetails
            });
        }

        return null;
    };

    _reverseDentalClaim = async () => {
        const success = await this.props.dispatch(reverseDentalClaim(this.props.claimID));

        if (success) {
            this._closeModal();
        }
    };

    render() {
        const { user, cert, claimID, uid, submitted = 0, claimed = 0, type, benefit, claimType, isAdjudicationList, status, assignedTo, serviceDate, submissionDate, isHeader, testid, userID, isSpendingAccount = false, adjudicators = [], claimBlocked } = this.props;
        const styles = {
            headerBlockRow: {
                display: 'flex',
                flex: 1,
                alignItems: 'center',
                flexDirection: 'row',
                height: 30,
                marginBottom: 5
            },
            typeBlock: {
                display: 'flex',
                flex: 2,
                alignItems: 'flex-start',
                backgroundColor: Theme.colors.lightBlue,
                flexDirection: 'column',
                height: '100%',
                justifyContent: 'center',
                padding: "0 20px"
            },
            block: {
                display: 'flex',
                flex: 1,
                alignItems: 'center',
                flexDirection: 'row',
                justifyContent: 'flex-end'
            },
            moreIcon: {
                padding: "12px",
                color: Theme.colors.mainTextGrey
            }
        };

        if (isHeader) {
            return (
                <div style={styles.headerBlockRow}>
                    <div style={{ ...styles.typeBlock, backgroundColor: Theme.colors.backgroundGrey, padding: "0 15px" }}>
                        <Text small>Type</Text>
                    </div>

                    <div style={styles.block}>
                        <Text small>Service Date</Text>
                    </div>

                    <div style={styles.block}>
                        <Text small>Date Submitted</Text>
                    </div>

                    <div style={styles.block}>
                        <Text small>Identifier</Text>
                    </div>

                    {
                        !isSpendingAccount &&
                            <div style={styles.block}>
                                <Text small>Submitted</Text>
                            </div>
                    }

                    <div style={styles.block}>
                        <Text small>Claimed</Text>
                    </div>

                    <div style={{ ...styles.block, flex: 1.5 }}>
                        <Text small>Assigned To</Text>
                    </div>

                    <div style={{ ...styles.block, paddingRight: '20px' }}>
                        <Text small>Status</Text>
                    </div>

                    <div style={{ ...styles.block, flex: 0.5 }}/>
                </div>
            );
        }

        let statusText = status.charAt(0).toUpperCase() + status.slice(1);
        let statusColor = null;

        if (statusText.toLowerCase() === 'flagged') {
            statusColor = 'red';
        } else if (statusText.toLowerCase() === 'approved') {
            statusColor = Theme.colors.skyBlue;
        } else if (statusText.toLowerCase() === 'paid') {
            statusColor = Theme.colors.brandGreen;
        }

        let claimLink = `/adjudication/${ claimID }`;

        if (!isAdjudicationList) {
            claimLink += `?${ userID }`;
        }

        if (!claimID) {
            claimLink = `/adjudication/simplyDental`;
        }

        return (
            <React.Fragment>
                <StyledBlockRow id={testid} style={{ backgroundColor: "#FFFFFF", boxShadow: "0 1px 2px rgb(0 0 0 / 15%)" }}>
                    {
                        isAdjudicationList ?
                            <div style={styles.typeBlock} onClick={ () => window.open(claimLink) }>
                                <Text medium light>{ benefit }</Text>
                                <Text tiny>
                                    { type.charAt(0).toUpperCase() + type.slice(1) }
                                </Text>
                            </div>
                            :
                            <div style={styles.typeBlock} onClick={ () => window.open(claimLink) }>
                                <Text medium light>{ user }</Text>
                                <Text tiny>
                                    { type.charAt(0).toUpperCase() + type.slice(1) }
                                </Text>
                            </div>
                    }

                    <div style={styles.block} onClick={ () => window.open(claimLink) }>
                        <Text medium light>
                            { dates.getStartOfDay(serviceDate, 'll') }
                        </Text>
                    </div>

                    <div style={styles.block} onClick={ () => window.open(claimLink) }>
                        <Text medium light>
                            { dates.getLocalDisplay(submissionDate) }
                        </Text>
                    </div>

                    <div style={styles.block} onClick={ () => window.open(claimLink) }>
                        <Text medium light>
                            { uid }
                        </Text>
                    </div>

                    {
                        !isSpendingAccount &&
                        <div style={styles.block} onClick={ () => window.open(claimLink) }>
                            <Text medium light>
                                { `$${ helpers.formatNumber(submitted) }` }
                            </Text>
                        </div>
                    }

                    <div style={styles.block} onClick={ () => window.open(claimLink) }>
                        <Text medium light>
                            { `$${ helpers.formatNumber(claimed) }` }
                        </Text>
                    </div>

                    <div style={{ ...styles.block, flex: 1.5 }} onClick={ () => window.open(claimLink) }>
                        <Text medium light>
                            { assignedTo }
                        </Text>
                    </div>

                    <div style={{ ...styles.block, paddingRight: '20px' }} onClick={ () => window.open(claimLink) }>
                        <Text medium bold color={ statusColor }>
                            { statusText }
                        </Text>
                    </div>

                    <div style={{ ...styles.block, flex: 0.5 }}>
                        <IconButton sx={styles.moreIcon} aria-label="Edit" onClick={this._handleMenuClick}>
                            <MoreVertIcon />
                        </IconButton>

                        <Menu
                            anchorEl={this.state.anchorEl}
                            open={Boolean(this.state.anchorEl)}
                            onClose={this._handleCloseMenu}
                            disableAutoFocusItem={true}
                            style={styles.menu}
                            anchorOrigin={ { vertical: "top", horizontal: "left" } }
                        >
                            { !claimBlocked
                                ? (
                                    <MenuItem onClick={() => this._openModal('showChangeStatus')} >
                                        <Text color="inherit" medium display="inline">
                                    Change Status
                                        </Text>
                                    </MenuItem> 
                                )
                                : null
                            }

                            <PermissionsComponent
                                permission="Reassign Claim"
                                accessType={this.props.access}
                                level="write"
                            >
                                {
                                    <MenuItem onClick={() => this._openModal('showReassign')} >
                                        <Text color="inherit" medium display="inline">
                                            Reassign
                                        </Text>
                                    </MenuItem>
                                }
                            </PermissionsComponent>

                            {
                                (benefit && benefit.toUpperCase() === 'DENTAL' && status.toUpperCase() === 'PENDING' && claimType.toUpperCase() === 'STANDARD') &&
                                    <div>
                                        <MenuItem
                                            onClick={ () => {
                                                window.location.href = `/adjudication/simplyDental/claim/${ cert }/${ claimID }/null`;
                                                return null;
                                            }}
                                        >
                                            <Text color="inherit" medium display="inline">
                                                Refer to Simply Dental (First Payor)
                                            </Text>
                                        </MenuItem>

                                        <MenuItem
                                            onClick={ () => {
                                                window.location.href = `/adjudication/simplyDental/cob/${ cert }/${ claimID }/null`;
                                                return null;
                                            }}
                                        >
                                            <Text color="inherit" medium display="inline">
                                                Refer to Simply Dental (COB)
                                            </Text>
                                        </MenuItem>
                                    </div>
                            }

                            <PermissionsComponent
                                permission="Reverse Dental Claims"
                                accessType={this.props.access}
                                level="write"
                            >
                                {
                                    (benefit && benefit.toUpperCase() === 'DENTAL' && claimType.toUpperCase() === 'STANDARD' && status.toUpperCase() !== 'PENDING' && status.toUpperCase() !== 'REVERSED' && status.toUpperCase() !== 'DECLINED') &&
                                    <MenuItem onClick={() => this._doDentalReversalStatusCheck()}>
                                        <Text color="inherit" medium display="inline">
                                            Reverse
                                        </Text>
                                    </MenuItem>
                                }
                            </PermissionsComponent>
                        </Menu>
                    </div>
                </StyledBlockRow>

                <Modal
                    open={this.state.showChangeStatus}
                    onClose={this._closeModal}
                    title="Change Status"
                    loader={this.props.loader}
                    primaryButton={{
                        label: "Save Status",
                        onClick: this._saveStatus
                    }}
                >
                    <Text
                        align="left"
                        medium
                        display="inline-block"
                        margin="10px 0"
                    >
                                    Update the status of the claim by selecting an option from the list below.
                    </Text>

                    <TextInput
                        label="Current Status"
                        value={status.charAt(0).toUpperCase() + status.slice(1)}
                        disabled
                        fullWidth
                        variant="outlined"
                        select
                        selectOptions={[
                            'Pending',
                            'Approved',
                            'Referred',
                            'Paid',
                            'Declined',
                            'Suspended',
                            'Incomplete'
                        ]}
                    />

                    <TextInput
                        label="New Status"
                        fullWidth
                        value={ this.state.newStatus || 'Pending' }
                        variant="outlined"
                        onChange={(e) => this._handleInputChange("newStatus", e.target.value)}
                        select
                        selectOptions={[
                            'Pending',
                            'Referred',
                            'Paid',
                            'Suspended',
                            'Incomplete'
                        ]}
                    />
                </Modal>

                <Modal
                    open={this.state.showReassign}
                    onClose={this._closeModal}
                    title="Reassign Adjudicator"
                    loader={this.props.loader}
                    primaryButton={{
                        label: "Reassign",
                        onClick: this._reassign
                    }}
                >
                    <div>
                        <Text
                            align="left"
                            medium
                            display="inline-block"
                            margin="10px 0"
                        >
                                    Reassign this claim to a different adjudicator by selecting an option from the list below.
                        </Text>

                        <TextInput
                            label="Current Adjudicator"
                            value={assignedTo}
                            disabled
                            fullWidth
                            variant="outlined"
                            select
                            selectOptions={[ 'Unassigned', ...adjudicators ]}
                        />

                        <TextInput
                            label="New Adjudicator"
                            fullWidth
                            value={ this.state.assignTo }
                            variant="outlined"
                            onChange={(e) => this._handleInputChange("assignTo", e.target.value)}
                            select
                            selectOptions={ adjudicators.filter((item) => item !== 'All' && item !== 'Unassigned') }
                        />
                    </div>
                </Modal>

                <ReverseDentalClaimModal
                    open={this.state.showDentalReversal}
                    onClose={this._closeModal}
                    title="Reverse Dental Claim"
                    loader={this.props.loader}
                    reversalDetails={this.state.reversalDetails}
                    reverseDentalClaim={this._reverseDentalClaim}
                />
               
            </React.Fragment>
        );
    }
}


/**
 *
 * @param {*} state
 */
const mapStateToProps = (state) => ({
    loader: state.loader,
    access: state.master.access
});

export default connect(mapStateToProps)(ClaimBlock);